import { MutableRefObject, useMemo, useRef } from 'react';

import { createCanvas } from 'lib/utils/canvas';

const useMeasureText = ({ text }: { text: string }) => {
  const canvasRef: MutableRefObject<HTMLCanvasElement | null> = useRef(null);

  return useMemo(() => {
    if (canvasRef.current == null) {
      // TODO: cleanup canvas on unmount
      const [canvas, _cleanupCanvas] = createCanvas();
      canvasRef.current = canvas;
    }

    const { current } = canvasRef;
    const context = current.getContext('2d');

    if (context != null) {
      context.clearRect(0, 0, current.width, current.height);
      context.font = getComputedStyle(document.body).font;
      return context.measureText(text).width;
    }

    return 0;
  }, [text]);
};

export default useMeasureText;
